import styled from 'styled-components';
import { Switch as BaseSwitch } from '@mui/material';
import { componentToken } from '../../style/utils';

const Switch = styled(BaseSwitch)`
  width: 32px;
  height: 16px;
  padding: 0;
  & .MuiSwitch-switchBase {
    padding: 0;
    margin: ${componentToken('switch.root.switchBaseMargin')};
    transition-duration: 300ms;
    &.Mui-checked {
      transform: translateX(16px);
      color: ${componentToken('switch.root.switchBaseCheckedColor')};
      & + .MuiSwitch-track {
        background-color: ${componentToken(
          'switch.root.checkedTrackBackgroundColor',
        )};
        opacity: 1;
        border: 0;
      }

      &.Mui-disabled + .MuiSwitch-track {
        opacity: 0.5;
      }
    }

    &.Mui-focusVisible .MuiSwitch-thumb {
      color: ${componentToken('switch.root.focusVisibleThumbColor')};
      border: 6px solid ${componentToken('switch.root.focusVisibleThumbBorder')};
    }

    &.Mui-disabled .MuiSwitch-thumb {
      color: ${componentToken('switch.root.disabledThumbColor')};
    }

    &.Mui-disabled + .MuiSwitch-track {
      opacity: 0.7;
    }
  }

  & .MuiSwitch-thumb {
    box-sizing: border-box;
    width: 12px;
    height: 12px;
  }

  & .MuiSwitch-track {
    border-radius: ${componentToken('switch.root.trackBorderRadius')};
    background-color: ${componentToken('switch.root.trackBackgroundColor')};
    opacity: 1;
    transition: background-color 0.5s ease;
  }
`;

export default Switch;
